import React from "react";
import "./main.css";

const Upward = () => {
  return (
    <div className="arrow" id="arrow">
      <a href="#home">
        <i className="fa fa-arrow-up" aria-hidden="true"></i>
      </a>
    </div>
  );
};

export default Upward;
